import { initTabletValue } from "./init-tablet-value";
import { initTabletOpenPortrait } from "./init-tablet-open-portrait";
import { initTabletOpenLandscape } from "./init-tablet-open-landscape";
import { initTabletClosePortrait } from "./init-tablet-close-portrait";
import { initTabletCloseLandscape } from "./init-tablet-close-landscape";

type SidebarStatus = "open" | "close";
type Orientation = "portrait" | "landscape";

type TabletSelectors = ReturnType<typeof initTabletOpenPortrait>;

const STORAGE_KEY = "toggleSlider";
const ORIENTATION_KEY = "orientationAngle";

const readSidebarStatus = (): SidebarStatus | null => {
  const value = localStorage.getItem(STORAGE_KEY);

  if (value === "open" || value === "close") {
    return value;
  }

  return null;
};

const resolveCurrentOrientation = (): Orientation | null => {
  const orientationType = screen.orientation?.type ?? "";

  if (orientationType.includes("portrait")) {
    return "portrait";
  }

  if (orientationType.includes("landscape")) {
    return "landscape";
  }

  return null;
};

export const handleOrientationChange = (): TabletSelectors | undefined => {
  const sideStatus = readSidebarStatus();
  const orientation = resolveCurrentOrientation();

  if (!sideStatus || !orientation) {
    return undefined;
  }

  const {
    sidebarColumnsPortrait,
    mainColumnsPortrait,
    wholeLeftPositionOpen,
    wholeLeftPositionCloseLandscape,
    wholeLeftPositionClosePortrait,
    sidebarColumnsLandscape,
    mainColumnsLandscape,
    mainColumnsFillwidth,
  } = initTabletValue();

  let selectors: TabletSelectors | undefined;
  let resolvedAngle: Orientation | undefined;

  if (sideStatus === "open" && orientation === "portrait") {
    selectors = initTabletOpenPortrait({
      wholeLeftPositionOpen,
      sidebarColumnsPortrait,
      mainColumnsPortrait,
    });
    resolvedAngle = "portrait";
  } else if (sideStatus === "open" && orientation === "landscape") {
    selectors = initTabletOpenLandscape({
      wholeLeftPositionOpen,
      sidebarColumnsLandscape,
      mainColumnsLandscape,
    });
    resolvedAngle = "landscape";
  } else if (sideStatus === "close" && orientation === "portrait") {
    selectors = initTabletClosePortrait({
      wholeLeftPositionClosePortrait,
      sidebarColumnsPortrait,
      mainColumnsFillwidth,
    });
    resolvedAngle = "portrait";
  } else if (sideStatus === "close" && orientation === "landscape") {
    selectors = initTabletCloseLandscape({
      wholeLeftPositionCloseLandscape,
      sidebarColumnsLandscape,
      mainColumnsFillwidth,
    });
    resolvedAngle = "landscape";
  }

  if (resolvedAngle) {
    localStorage.setItem(ORIENTATION_KEY, resolvedAngle);
  }

  return selectors;
};
